import { ref, watch } from 'vue';

const STORAGE_KEY = 'bui.nav.collapsed';

const collapsed = ref<boolean>(readInitial());

function readInitial(): boolean {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored !== null) return stored === '1';
  } catch {
    // localStorage may be unavailable (private mode) — fall through.
  }
  // No saved preference: start collapsed on narrow viewports so the rail
  // doesn't crush page content on phones/small tablets.
  try {
    return window.matchMedia('(max-width: 900px)').matches;
  } catch {
    return false;
  }
}

watch(collapsed, (v) => {
  try {
    localStorage.setItem(STORAGE_KEY, v ? '1' : '0');
  } catch {
    // localStorage may be unavailable (private mode) — silently ignore.
  }
});

export function useNavCollapse() {
  function toggle() { collapsed.value = !collapsed.value; }
  function setCollapsed(v: boolean) { collapsed.value = v; }
  return { collapsed, toggle, setCollapsed };
}

export default useNavCollapse;
